<i class="cursor-po-c fa fa-bars categories-bars" (click)="openCategories = !openCategories" *ngIf="categories"></i>
<div class="categories-menu" [ngClass]="{'d-block': openCategories}" *ngIf="type == 1">
    <ng-container *ngFor="let category1 of categories">
        <!-- 1st Level -->
        <button class="categories-menu-btns" mat-button [matMenuTriggerFor]="menu2" *ngIf="category1.categories">{{ category1.name }}</button>
        <a class="categories-menu-btns text-style" mat-button *ngIf="!category1.categories" [href]="'#/catalog/' + category1.id" (click)="closeNav()">{{ category1.name }}</a>

        <mat-menu #menu2="matMenu">
            <ng-container *ngFor="let category2 of category1.categories">
                <!-- 2nd Level -->
                <button mat-menu-item [matMenuTriggerFor]="menu3" *ngIf="category2.categories">
                {{ category2.name }}
            </button>

                <a class="text-style" mat-menu-item *ngIf="!category2.categories" [href]="'#/catalog/' + category2.id" (click)="closeNav()">{{ category2.name }}</a>

                <!-- 3rd Level -->
                <mat-menu #menu3="matMenu">
                    <a class="text-style" mat-menu-item *ngFor="let category3 of category2.categories" [href]="'#/catalog/' + category3.id" (click)="closeNav()">{{ category3.name }}</a>
                </mat-menu>
            </ng-container>
        </mat-menu>
    </ng-container>
</div>

<div class="categories-menu" [ngClass]="{'d-block': openCategories}" *ngIf="type == 2">
    <ng-container *ngFor="let category1 of categories">
        <a class="categories-menu-btns text-style" mat-button [href]="'#/'+ (!category1.categories ? 'catalog/' :'catalogs/')  + category1.id" (click)="closeNav()">{{ category1.name }}</a>
    </ng-container>
</div>